import React from 'react';
import { Button } from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PersonAddIcon from '@mui/icons-material/PersonAdd';

const UsersToolbarActions = ({ tab, saving }) => {
    const { setProvisioningDialog } = tab;

    return (
        <>
            <Button
                variant="outlined"
                startIcon={<MailOutlineIcon />}
                onClick={() => setProvisioningDialog('templates')}
                disabled={saving}
            >
                E-mailskabeloner
            </Button>
            <Button
                variant="contained"
                startIcon={<PersonAddIcon />}
                onClick={() => setProvisioningDialog('create')}
                disabled={saving}
            >
                Opret brugere
            </Button>
        </>
    );
};

export default UsersToolbarActions;
